import { Box } from '@mui/material';
import React from 'react';
import { ReactComponent as WarningIcon } from '../../../../../assets/icons/ContractErrorIcon.svg';
import { ContractCardCheckbox, ContractHours } from './styles';
import { ContractCardHeaderProps } from '../types';

const ContractCardHeader: React.FC<ContractCardHeaderProps> = ({ card, onChangeCardCheck, isEmployee }) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" position="relative">
      <ContractHours error={card.hasError} warning={card.hasWarning}>
        {card.startHour} - {card.endHour}
        <Box sx={{ marginLeft: '5px' }}>{card.hasError && <WarningIcon width={20} height={20} />} </Box>
      </ContractHours>
      {card.checked && !isEmployee && (
        <ContractCardCheckbox checked={card.checked} onChange={() => onChangeCardCheck(card.contractId)} />
      )}
    </Box>
  );
};

export default ContractCardHeader;
